import { render, staticRenderFns } from "./business-form.vue?vue&type=template&id=185781ba"
import script from "./business-form.vue?vue&type=script&lang=js"
export * from "./business-form.vue?vue&type=script&lang=js"
import style0 from "./business-form.vue?vue&type=style&index=0&id=185781ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports